import { useTranslation } from "react-i18next";
import ModalContainer from "../../containers/Modal/ModalContainer";
import { useEffect, useState } from "react";
import { TagService } from "../../services/TagService";

export default function AddNewTagModal({
  isOpen,
  closeModal,
  tagEdit,
  groups,
  onClose,
  onSubmmitSuccess,
  modalTitleProp,
  buttonTitleProp
}) {
  const [tag, setTag] = useState({});
  const [error, setError] = useState({});
  const { t } = useTranslation();
  const [modalTitle, setModalTitle] = useState(modalTitleProp || t("New Tag"));
  const [buttonTitle, setButtonTitle] = useState(buttonTitleProp || t("Create"));

  useEffect(() => {
    if (modalTitleProp) {
      setModalTitle(modalTitleProp);
    }
  }, [modalTitleProp]);

    useEffect(() => {
    if (buttonTitleProp) {
      setButtonTitle(buttonTitleProp);
    }
  }, [buttonTitleProp]);

  useEffect(() => {
    if (tagEdit && tagEdit.id) {
      setModalTitle(t("Edit Tag"));
    } else {
      setModalTitle(t("New Tag"));
    }
  }, [tagEdit, isOpen]);

    useEffect(() => {
    if (tagEdit && tagEdit.id) {
      setButtonTitle(t("Edit"));
    } else {
      setButtonTitle(t("Create"));
    }
  }, [tagEdit, isOpen]);

  const submmit = () => {
    if (valid())
      if (!tagEdit.id) {
        createTag();
      } else {
        updateTag();
      }
  };

  function createTag() {
    TagService.createTag(tag).then(() => {
      setTag({});
      closeModal();
      if (onSubmmitSuccess) {
        onSubmmitSuccess();
      }
    });
  }
  function updateTag() {
    TagService.update(tag).then(() => {
      setTag({});
      closeModal();
      if (onSubmmitSuccess) {
        onSubmmitSuccess();
      }
    });
  }

  function valid() {
    const error = {};
    if (!tag.name) error.name = t("Name is required");

    setError(error);
    return Object.keys(error).length === 0;
  }

  useEffect(() => {
    setTag(tagEdit);
  }, [tagEdit.id]);

  function onChange({ target }) {
    setTag({ ...tag, [target.name]: target.value });
  }

  function handleClose() {
    closeModal();
    if (onClose) {
      onClose();
    }
  }


  return (
    <ModalContainer
      isOpen={isOpen}
      modalTitle={modalTitle}
      closeModal={handleClose}
      crossmarkAction={handleClose}
      cancelButtonAction={handleClose}
      cancelButtonTitle="Cancel"
      submitButtonTitle={buttonTitle}
      modalSize="sm"
      submitButtonAction={submmit}
    >
      <div className="row">
        <div className="col-12">
          <div className="mb-3 form-group" style={{flexFlow: "row"}}>
            <div className="col-6" style={{paddingRight: "10px"}}>
              <label htmlFor="tag-name" className="form-label">
                {t("Name")}
                {error.name && <span className="error-msg">{error.name}</span>}
              </label>
              <input
                type="text"
                className="form-control"
                id="tag-name"
                name="name"
                onChange={onChange}
                value={tag.name}
                placeholder={t("Enter tag name")}
              />
            </div>
            <div className="col-5" style={{paddingRight: "10px"}}>
              <label htmlFor="tag-icon" className="form-label">
                {t("Group")}
              </label>
              <select
                className="form-select"
                id="tag-groupId"
                aria-label="Default select example"
                name="companyTagGroupId"
                value={tag.companyTagGroupId}
                onChange={onChange}
              >
                <option>{t("Select tag group")}</option>
                {groups.map((group) => {
                  return <option value={group.id}>{group.name}</option>;
                })}
              </select>
            </div>
            <div>
              <label for="color" class="form-label">
                {t("Color")}
              </label>
              <input
                type="color"
                class="form-control form-control-color"
                id="color"
                name="color"
                value={tag.color}
                title="Choose your color"
                onChange={onChange}
              />
            </div>
          </div>
          <div className="mb-3 form-group">
            <label htmlFor="tag-description" className="form-label">
              {t("Description")}
            </label>
            <textarea
              className="form-control"
              id="tag-description"
              rows="3"
              name="description"
              placeholder={t("Enter description")}
              onChange={onChange}
              value={tag.description}
            ></textarea>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
}
